export interface ApartmentPrefill {
  price_month: number
  area_m2: number
  room_count: number
  location: string
}

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max)
}

export function prefillRentAreaRanges(prefill: Pick<ApartmentPrefill, 'price_month' | 'area_m2'>) {
  return {
    rent_min: clamp(prefill.price_month - 100, 100, 2000),
    rent_max: clamp(prefill.price_month + 100, 100, 2000),
    area_min: clamp(prefill.area_m2 - 10, 15, 130),
    area_max: clamp(prefill.area_m2 + 10, 15, 130)
  }
}

export function matchRoomId(
  rooms: { id?: string; name?: string }[],
  roomCount: number
): string | undefined {
  const countStr = String(roomCount)
  const exact = rooms.find((room) => room.name === countStr)
  if (exact?.id) return exact.id

  return rooms.find(
    (room) =>
      room.id &&
      (room.name?.includes(countStr) ||
        new RegExp(`\\b${countStr}\\b`).test(room.name ?? ''))
  )?.id
}

export function matchLocationId(
  options: { value: string; label: string }[],
  location: string
): string | undefined {
  const normalized = location.trim().toLowerCase()
  if (!normalized) return undefined

  const exact = options.find(
    (option) => option.label.toLowerCase() === normalized
  )
  if (exact) return exact.value

  const partial = options.find(
    (option) =>
      option.label.toLowerCase().includes(normalized) ||
      normalized.includes(option.label.toLowerCase())
  )
  return partial?.value
}
